import React, { useEffect, useState } from "react";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import NewsData from "../assets/news/NewsData";
import NewsDatajson from "../assets/news.json";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";

const News = () => {
  const [date, setDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [news, setNews] = useState([]);

  const data = [
    {
      id: 1,
      title: "Auction of Government of India Dated Securities",
      date: "29/11/2021",
      newsURL: "assets/news/CG%20Nov%2029.PDF",
    },
    {
      id: 2,
      title: "Sovereign Gold Bond (SGB) Issuance on RBI Retail Direct",
      date: "29/11/2021",
      newsURL: "assets/news/SGB%20Nov%2029.PDF",
    },
    {
      id: 6,
      title: "91 Days, 182 Days and 364 Days Treasury Bills Auction Dummy 2",
      date: "28/11/2021",
      newsURL: "assets/news/TB_Nov%2026.PDF",
    },
    {
      id: 3,
      title: "Government Stock - Full Auction Results",
      date: "26/11/2021",
      newsURL: "assets/news/CG_Results_Nov%2026.PDF",
    },
    {
      id: 4,
      title: "91 Days, 182 Days and 364 Days Treasury Bills Auction",
      date: "26/11/2021",
      newsURL: "assets/news/TB_Nov%2026.PDF",
    },
    {
      id: 5,
      title: "91 Days, 182 Days and 364 Days Treasury Bills Auction Dummy",
      date: "26/11/2021",
      newsURL: "assets/news/TB_Nov%2026.PDF",
    },
  ];
  useEffect(() => {
    
    window.scrollTo(0, 0);
    axios
      .get("/api/api/news")
      .then((response) => {
        console.log("response-->>", response);
        let newsData = [];
        if (response && response.data && response.data.length > 0) {
          response.data.forEach((element) => {
            let index = newsData.findIndex((ele) => ele.date == element.date);
            if (index != -1) {
              newsData[index] = {
                date: element.date,
                news: [...newsData[index].news, element],
              };
            } else {
              newsData.push({
                date: element.date,
                news: [element],
              });
            }
          });
        }
        setNews(newsData);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  }, []);

  return (
    <div>
      <NavBar />
      <main id="main">
        <section id="faq" className="innerPage">
          <div className="container">
            <div className="section-title">
              <h2>ഏറ്റവും പുതിയ വാർത്തകളും പ്രഖ്യാപനങ്ങളും</h2>
            </div>
            <div className="row">
              <div className="col-lg-12 d-flex latest">
                {isLoading ? (
                  <div
                    style={{
                      marginTop: "10%",
                      marginLeft: "50%",
                    }}
                  >
                    <CircularProgress
                      variant="indeterminate"
                      value={100}
                      size={50}
                      color={"inherit"}
                    />
                  </div>
                ) : (
                  <ul>
                    {news &&
                      news.map((element, index) => (
                        <div>
                          <li className="news-date">{element.date}</li>
                          {element &&
                            element.news &&
                            element.news.map((ele, index) => {
                              return (
                                <li>
                                  <i className="ri-file-pdf-line"></i>{" "}
                                  <a href={ele.newsURL} target="_blank">
                                    {ele.title}
                                  </a>
                                </li>
                              );
                            })}
                        </div>
                      ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer footerClass="footerFixed" />
    </div>
  );
};

export default News;
